import * as types from "./actionTypes";

export function enterGuess(guess, guessdigit) {
  return { type: types.ENTER_GUESS, guess, guessdigit };
}
